import * as FSSolidIcon from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import {utils} from "@utils";
import styles from "./style.module.scss";
import {AdminScreenId} from "@assets";
import {useAdminNav} from "@hook";

type TRightCountType = "qnaCount";

interface IParams {
  [key: string]: string | number | undefined;
}
interface IMenuOrigin {
  title: string;
  rightCount?: TRightCountType;
  icon?: any;
  link?: AdminScreenId;
  isOpen?: boolean;
  params?: IParams;
}
interface IMenu extends IMenuOrigin {
  detail?: IMenuOrigin[];
}

export const initMenu: IMenu[] = [
  {title: "리뷰목록", link: AdminScreenId.REVIEW_LIST},
];

export function Sidebar() {
  const {navigate} = useAdminNav();
  const location = useLocation();
  const nowPath = (location.pathname || "").slice(
    1,
    (location.pathname || "").length,
  );
  const [menu, setMenu] = useState<IMenu[]>(initMenu);

  function gotoLink({link, params}: {link: AdminScreenId; params?: IParams}) {
    if (nowPath === link) {
      window.location.replace(link);
    } else {
      navigate({url: link, params});
    }
  }

  return (
    <ul className={styles.sidebarMenu}>
      {menu.map((item, i) => {
        const isActive = nowPath === item.link;
        const rightCount = 0;
        const detailMenu = item.detail || [];

        return (
          <li
            key={i}
            className={[
              ...[isActive ? styles.active : undefined],
              ...[detailMenu.length > 0 ? styles.menuGroup : styles.menuItem],
              ...[item.isOpen ? styles.open : undefined],
            ].join(" ")}
            onClick={() => {
              if (item.link) {
                gotoLink({link: item.link, params: item.params});
              } else if ((item.detail || []).length > 0) {
                setMenu([
                  ...menu.map((_item, _index) =>
                    _index === i ? {..._item, isOpen: !_item.isOpen} : _item,
                  ),
                ]);
              }
            }}>
            <div className={styles.groupDiv}>
              {!!item.icon && (
                <FontAwesomeIcon icon={item.icon} className={styles.icon} />
              )}
              <span className={styles.submenuTitle}>
                {item.title}
                {rightCount > 0 && (
                  <span className={styles.menuCount}>
                    ({rightCount.toLocaleString()})
                  </span>
                )}
              </span>
            </div>
            {detailMenu.length > 0 && (
              <ul className={[styles.subMenu].join(" ")}>
                {detailMenu.map((subMenu, j) => {
                  const isSubActive = nowPath === subMenu.link;

                  return (
                    <li
                      key={j}
                      className={[
                        styles.subMenuItem,
                        ...[isSubActive ? styles.active : undefined],
                      ].join(" ")}
                      onClick={e => {
                        utils.handleClickBubble(e);
                        if (subMenu.link) {
                          gotoLink({
                            link: subMenu.link,
                            params: subMenu.params,
                          });
                        }
                      }}>
                      {!!subMenu.icon && (
                        <FontAwesomeIcon
                          icon={subMenu.icon}
                          className={styles.icon}
                        />
                      )}
                      <span className={styles.submenuTitle}>
                        {subMenu.title}
                      </span>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
}
